import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { db } from '../firebase/firebase-config';
import { collection, addDoc, getDocs, query, where } from 'firebase/firestore';

const AllSiteDetails = () => {
    const [sites, setSites] = useState([]);
    const [formData, setFormData] = useState({
        siteName: '',
        url: '',
        username: '',
    });
    const [userId, setUserId] = useState('');

    const sitesCollectionRef = collection(db, 'sites');

    useEffect(() => {
        // Retrieve userId from localStorage
        const storedUserId = localStorage.getItem('userId');
        if (storedUserId) {
            setUserId(storedUserId);
        } else {
            console.error('No userId found in localStorage!');
        }
    }, []);

    useEffect(() => {
        if (!userId) return;

        const fetchSites = async () => {
            try {
                // Query Firestore for documents with the specific userId
                const q = query(sitesCollectionRef, where('userId', '==', userId));
                const data = await getDocs(q);
                const fetchedSites = data.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setSites(fetchedSites);
            } catch (error) {
                console.error('Error fetching sites:', error);
            }
        };

        fetchSites();
    }, [userId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!userId) {
            console.error('Cannot add a site without a valid userId!');
            return;
        }

        try {
            // Add the userId to the formData
            const dataToSubmit = { ...formData, userId };

            const docRef = await addDoc(sitesCollectionRef, dataToSubmit);
            console.log('Document written with ID:', docRef.id);

            // Update the sites state with the new entry
            setSites((prevSites) => [
                ...prevSites,
                { id: docRef.id, ...dataToSubmit },
            ]);

            setFormData({
                siteName: '',
                url: '',
                username: '',
            });
        } catch (error) {
            console.error('Error adding site:', error);
        }
    };

    return (
        <div className="mt-5">
            <h3 className="text-center mb-3">All Site Details</h3>

            {/* Form to Add New Site */}
            <form className="form-inline" onSubmit={handleSubmit}>
                <div className="row gx-2 align-items-center">
                    <div className="col-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Site Name"
                            name="siteName"
                            value={formData.siteName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-3">
                        <input
                            type="url"
                            className="form-control"
                            placeholder="URL"
                            name="url"
                            value={formData.url}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-3 text-center">
                        <button type="submit" className="btn btn-primary w-100">
                            Add Site
                        </button>
                    </div>
                </div>
            </form>

            {/* Table to Display Site Details */}
            <table className="table table-striped mt-3">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Site Name</th>
                        <th>URL</th>
                        <th>Username</th>
                    </tr>
                </thead>
                <tbody>
                    {sites.map((site, index) => (
                        <motion.tr
                            key={site.id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <td>{index + 1}</td>
                            <td>{site.siteName}</td>
                            <td>
                                <a
                                    href={site.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary"
                                >
                                    {site.url}
                                </a>
                            </td>
                            <td>{site.username}</td>
                        </motion.tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AllSiteDetails;
